import {
  Modal,
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Radio,
  Row,
  Select,
} from "antd";
import { forwardRef, useState } from "react";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import axios from "axios";
import { useDispatch } from "react-redux";
import { authAction } from "hooks/actions/mainAction";

const backend = process.env.REACT_APP_BACKEND;
const { Option } = Select;

const InsertAdminUser = forwardRef(
  ({ menuGroupLists, emailValidator, emailSearchHandler }, userRef) => {
    const dispatch = useDispatch();
    const [userStatus, setUserStatus] = useState("1");
    const [assignedMenuGroupId, setAssignedMenuGroupId] = useState([]);
    // const [emailValidator, setEmailValidator] = useState(null)
    // function validator(_, value) {
    //   const newData = userRef.current.getFieldsValue();

    //   for (let el of dataSource) {
    //     if (el.id !== newData.menuId && el.menu_name === newData.menuName) {
    //       return Promise.reject(
    //         new Error(`메뉴에 "${el.menu_name}"가 이미 존재합니다.`)
    //       );
    //     }
    //   }
    //   return Promise.resolve();
    // }
    // console.log(userStatus);
    // console.log(assignedMenuGroupId);
    // console.log(menuGroupLists);
    function emailSearch(value) {
      userRef.current
        .validateFields(["email"])
        .then(async (res) => {
          // console.log(res);
          const result = await axios
            .post(`${backend}/admin_manage/email_search`, { value: res.email })
            .then((data) => {
              if (data.data.data.length === 0) {
                // setEmailValidator(true)
                emailSearchHandler(true);
                return true;
              } else {
                // setEmailValidator(false)
                emailSearchHandler(false);
                return false;
              }
            })
            .catch((err) => {
              if (err.response.status === 401) {
                Modal.error({
                  title: "인증 에러",
                  content: "인증이 만료되었습니다. 다시 로그인 해주세요.",
                  afterClose: () => {
                    dispatch(authAction(false, null));
                  },
                });
              }
              console.log(err);
            });
          // console.log(result);
        })
        .catch((err) => err);
    }

    function onChangeStatus(group) {
      // console.log(group.target.value);
      setUserStatus(group.target.value);
    }
    function onChangeMenuGroup(value) {
      // console.log(value);

      setAssignedMenuGroupId(value);
    }

    return (
      <div>
        <Form
          ref={userRef}
          layout="vertical"
          initialValues={{ status: "1", description: null, position: null }}
        >
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="email"
                label="계정(이메일)"
                onBlur={emailSearch}
                required={true}
                validateTrigger={["onChange","onBlur"]}
                rules={[
                  { required: true, message: "이메일은 필수 입력사항입니다." },
                  {
                    type: "email",
                    message: "이메일 주소 형식에 맞지 않습니다.",
                    validateTrigger: "onBlur"
                  },
                ]}
                extra={
                  emailValidator === null ? (
                    <></>
                  ) : emailValidator === true ? (
                    <div style={{ color: "blue" }}>
                      사용할 수 있는 이메일입니다.
                    </div>
                  ) : (
                    <div style={{ color: "red" }}>
                      사용할 수 없는 이메일입니다.
                    </div>
                  )
                }
              >
                <Input
                  onChange={() => {
                    emailSearchHandler(null);
                  }}
                ></Input>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="name"
                label="이름"
                required={true}
                rules={[
                  { required: true, message: "이름은 필수 입력사항입니다." },
                ]}
                extra={<></>}
              >
                <Input></Input>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="phone"
                label="휴대폰번호"
                required={true}
                rules={[
                  {
                    required: true,
                    message: "휴대폰번호는 필수 입력사항 입니다.",
                  },
                ]}
                extra={<></>}
              >
                <Input></Input>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="department"
                label="소속"
                required={true}
                rules={[
                  { required: true, message: "소속은 필수 입력사항입니다." },
                ]}
              >
                <Input></Input>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="responsibility"
                label="직책"
                required={true}
                rules={[
                  { required: true, message: "직책은 필수 입력사항입니다." },
                ]}
              >
                <Input></Input>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="position" label="직급">
                <Input></Input>
              </Form.Item>
            </Col>
          </Row>
          <Col>
            <Form.Item
              name="assignedMenuGroup"
              label="관리영역"
              required={true}
              rules={[
                { required: true, message: "관리영역은 필수 입력사항 입니다." },
              ]}
            >
              <Checkbox.Group
                onChange={onChangeMenuGroup}
                value={assignedMenuGroupId}
              >
                {menuGroupLists.map((ele) => (
                  <Row key={ele.id}>
                    <Checkbox value={ele.id}>{ele.menu_group_name}</Checkbox>
                  </Row>
                ))}
              </Checkbox.Group>
            </Form.Item>
          </Col>
          <Row>
            <Col span={24}>
              <Form.Item name="description" label="메모">
                <Input.TextArea></Input.TextArea>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Form.Item
              name="status"
              label="계정 상태"
              required={true}
              rules={[
                { required: true, message: "계정상태는 필수 입력사항 입니다." },
              ]}
            >
              <Radio.Group onChange={onChangeStatus}>
                <Radio value="1">정상</Radio>
                <Radio value="0">해지</Radio>
              </Radio.Group>
            </Form.Item>
          </Row>
          {/* <Form.Item
          name="menuName"
          label="메뉴명칭"
          rules={[
            { required: true, message: "관리메뉴 명칭을 입력해 주세요." },
            { validator: validator },
          ]}
        >
          <Input></Input>
        </Form.Item>
        <Form.Item
          name="menuURL"
          label="메뉴 URL"
          rules={[{ required: true, message: "관리메뉴 URL을 입력해 주세요." }]}
        >
          <Input addonBefore="https://"></Input>
        </Form.Item> */}
        </Form>
      </div>
    );
  }
);

export default InsertAdminUser;
